import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Cookies from "js-cookie";
import { useAuth } from "../../../utils/AuthContext";
import { useState } from "react";

function useLogout() {
  const navigate = useHistory();
  const { setIsLoggedIn, setUser } = useAuth();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const showLogoutConfirmation = () => {
    setShowLogoutModal(true);
  };

  const hideLogoutConfirmation = () => {
    setShowLogoutModal(false);
  };

  const logoutUserFn = async () => {
    setIsLoggingOut(true);
    try {
      setIsLoggedIn(false);
      localStorage.clear();
      Cookies.remove("auth_token");
      setUser([]);
      navigate.push("/signin");
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      setIsLoggingOut(false);
      setShowLogoutModal(false);
    }
  };

  return {
    logoutUserFn,
    showLogoutConfirmation,
    hideLogoutConfirmation,
    showLogoutModal,
    isLoggingOut,
  };
}

export default useLogout;
